
export const sFechaPublicacion = '2026-10-26T14:46:59.1347153-06:00';
export const sVersion = 'vAppComedor0.1.610261446';
            